import httpClient from "Api/httpClient";

const END_POINT = "notifications/";
const ME_END_POINT = "me/notifications/";

const getNotifications = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getNotification = (notification_id) => {
    if (!notification_id) return;
    const SINGLE_ME_END_POINT = ME_END_POINT + "/" + notification_id;
    return httpClient.get(SINGLE_ME_END_POINT);
};

const printNotification = (notification_id) => {
    if (!notification_id) return;
    const SINGLE_ME_END_POINT = ME_END_POINT + "/print?notification_id=" + notification_id;
    return httpClient.get(SINGLE_ME_END_POINT);
};

const createNotifications = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(ME_END_POINT, body);
};

const updateNotifications = (payload, notification_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_ME_END_POINT = ME_END_POINT + "/" + notification_id;
    return httpClient.patch(UPDATE_ME_END_POINT, body);
};

const deleteNotifications = (notification_id) => {
    const DELETE_ME_END_POINT = ME_END_POINT + "/" + notification_id;
    return httpClient.delete(DELETE_ME_END_POINT, { retryTimes: 3 });
};

const sendEmail = (payload, endpoint) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(endpoint, body);
};

const readOrUnreadNotifications = (payload, notification_id, readorunread) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const READ_ME_END_POINT = ME_END_POINT + "/" + notification_id + "/" + readorunread;
    return httpClient.patch(READ_ME_END_POINT, body);
};

const getMeNotifications = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(ME_END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

export {
    getNotifications,
    getNotification,
    printNotification,
    createNotifications,
    updateNotifications,
    deleteNotifications,
    sendEmail,
    readOrUnreadNotifications,
    getMeNotifications,
};
